import type {IAugmentedJQuery, IDocumentService, IOnDestroy, IPostLink} from 'angular';
import type {BarcodeScannerService} from '../barcode-scanner.service';
import type {Component} from 'typings/portaro.fe.types';
import './kp-barcode-scanner-viewer.less';

export class BarcodeScannerViewerComponentController implements KpBarcodeScannerViewerComponentBinding, IPostLink, IOnDestroy {

    readonly appendToBody?: boolean;

    private readonly element: HTMLElement; // native self reference
    private videoElement: HTMLVideoElement;

    /*@ngInject*/
    constructor($element: IAugmentedJQuery,
                private $document: IDocumentService,
                private barcodeScannerService: BarcodeScannerService) {

        this.element = $element[0];
        this.element.style.display = 'none'; // ng-show is not working properly, this is more reliable
    }

    $postLink(): void {

        if (this.appendToBody) {
            this.$document[0].body.append(this.element)
        }

        if (!this.barcodeScannerService.isUsable()) {
            return;
        }

        this.videoElement = this.element.querySelector('#barcode-scanner-video');
        this.barcodeScannerService.registerScannerViewer(this);
    }

    $onDestroy(): void {

        if (this.barcodeScannerService.isUsable()) {
            this.barcodeScannerService.unregisterScannerViewer();
        }

        if (this.appendToBody) {
            this.element.remove();
        }
    }

    public openViewer() {
        this.element.style.display = ''; // ng-show is not working properly, this is more reliable
    }

    public closeViewer() {
        this.element.style.display = 'none'; // ng-show is not working properly, this is more reliable
    }

    public getVideoElement(): HTMLVideoElement {
        return this.videoElement;
    }
}

export class KpBarcodeScannerViewerComponent implements Component<KpBarcodeScannerViewerComponentBinding> {

    public static readonly componentName = 'kpBarcodeScannerViewer';
    public templateUrl = require('./kp-barcode-scanner-viewer.tpl.ftl');
    public controller = BarcodeScannerViewerComponentController;
    public bindings = {
        appendToBody: '<?'
    } as const
}

interface KpBarcodeScannerViewerComponentBinding {
    appendToBody?: boolean
}